import SystemCheck from '../interfaces/systemCheck';
import { HttpClient } from './http-client';

export class HealthService extends HttpClient {
  check() {
    return this.get<SystemCheck>(`/api/internal/health`);
  }
}
